import React, { useEffect } from "react";
import styled from "styled-components";
import { SOFT_TOMATO } from "../components/colors";
import Navigation from "../components/commons/organisms/Navigation";
import { useAuth } from "../contexts/AuthContext";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import usePageView from "../hooks/use-page-view";
import { MIXPANEL_ACTION, MIXPANEL_PAGE } from "../utils/constants";
import MixpanelService from "../utils/mixpanel";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;

  @media(min-width: 768px) {
    max-width: 1200px; /* or 1280px */
    margin: 0 auto;
    padding: 1rem 1rem; /* optional side padding */
    flex-direction: row-reverse;
  }
`;

const Title = styled.div`
  p {
    font-family: 'Poppins-SemiBold';
    font-size: 1rem;
    margin: 0 0;
  }
`;

const Subtitle = styled.div`
  p {
    font-family: 'Poppins-Medium';
    font-size: 0.8rem;
    margin: 0 0;
  }
`;

const LeftPane = styled.div`
  // border: 1px solid red;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  align-items: center;
  padding: 1rem 0rem;

  @media(min-width: 768px) {
    padding: 0rem;
  }
`;
 

const RightPane = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const BigLogo = styled.div`
  height: 180px;
  img {
    height: 180px;
    object-fit: cover;
  }
`;

const ConsumerInfo = styled.div`
  p {
    text-align: left;
    font-family: 'Poppins-Medium';
    font-size: 0.8rem;
    margin-bottom: 0;
    color: ${SOFT_TOMATO}
  }

  span {
    text-align: left;
    font-family: 'Poppins-Medium';
    font-size: 0.8rem;
  }
`;

const ErrorLabel = styled.div`
  p {
    font-family: 'Poppins-SemiBold';
    font-size: 0.8rem;
    margin: 0 0;
    color: red;
    margin-top: 1rem;
  }
`;

const ButtonSignOut = styled.button`
  width: 100%;
  border: none;
  background-color: ${SOFT_TOMATO};
  color: white;
  border-radius: 6px;
  height: 40px;
  font-family: 'Poppins-SemiBold';
  font-size: 0.8rem;
  margin: 1rem 0rem;

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
    color: #666;
  }
`;

const Account = () => {

  const { 
    user,
    refreshUser,
  } = useAuth();

  const navigate = useNavigate();
  usePageView(MIXPANEL_PAGE.ACCOUNT);

  const customerInfo: {
    label: string;
    value: any;
  }[] = [{
    label: 'EMAIL',
    value: user?.email || ''
  }, {
    label: 'MOBILE',
    value: user?.mobile || ''
  }, {
    label: 'ADDRESS',
    value: user?.address || {}
  }];

  useEffect(() => {
    if (!user) {
      navigate('/login')
    }
  }, [])

  const renderCustomerAddress = (address: any) => {
    const keys = Object.keys(address);
    return (
      <>
        {keys.map((key) => (
          <>
          <span>{address[key]}</span>
          <br/>
          </>
        ))}
      </>
    )
  }

  return (
    <>
      <Navigation />
      <Container>
        <LeftPane>
          <BigLogo>
            <img src={require('../assets/hg-logo.png')} />
          </BigLogo>       
        </LeftPane>
        <RightPane>
          <Title>
            <p>{'Profile Information'.toUpperCase()}</p>
          </Title>
          <Subtitle>
            <p>{'Keep your personal details up to date to ensure a smooth checkout experience.'.toUpperCase()}</p>
          </Subtitle>
          {
            customerInfo.map((info) => {
              if (info.label === 'ADDRESS') {
                return (
                  <ConsumerInfo>
                    <p>{info.label || ''}</p>
                    {renderCustomerAddress(info.value)}
                  </ConsumerInfo>
                )
              } else {
                return (
                  <ConsumerInfo>
                    <p>{info.label}</p>
                    <span>{info.value || ''}</span>
                  </ConsumerInfo>
                )
              }
            })
          } 
          <ButtonSignOut
            onClick={() => {
              MixpanelService.track(`${MIXPANEL_PAGE.ACCOUNT} - ${MIXPANEL_ACTION.BUTTON_CLICK}`)
              Cookies.remove('token')
              refreshUser();
              navigate('/login');
            }}
          >
            <p>SIGNOUT</p>
          </ButtonSignOut>
        </RightPane>
      </Container>
    </>
  )
}

export default Account;